module.exports = __webpack_public_path__ + "static/GlitchlessSonyax49-fe9dd7081cff2ebc5d5a24a759d1c567.png";